<template>
  <iMineTemplate
    :page-title="pageTitle"
    :actived-parent-key="activedParentKey"
    :actived-key="activedKey"
  >
    <template #rightContent>
      <div v-loading="loading" class="brokerage-container">
        <!-- banner -->
        <div class="banner-box">
          <el-carousel
            trigger="click"
            class="swipe"
            :duration="300"
            loop
            indicator-color="#126CE1"
          >
            <el-carousel-item v-for="(img, index) in loopImgs" :key="index">
              <img :src="img.ImageUrl" class="swiper-img" width="100%" fit="cover" @click.stop="goRouter(img)">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div>
          <!-- 免费领取 -->
          <div class="type-box type-free">
            <div class="type-title">  <div style="position: relative;">免费领取 <div class="dot-right-blue">免</div> </div>  </div>
            <div class="type-list">
              <template v-if="freeBrokerageLists.length">
                <div v-for="(val,idx) in freeBrokerageLists" :key="idx" class="type-list-item">
                  <div class="type-item-tag">
                    <span>免费</span>
                  </div>
                  <div class="type-list-img" @click.stop="checkDetails(val)">
                    <img :src="val.ImageUrl" fit="cover">
                  </div>
                  <div class="type-list-name">{{ val.Name }}</div>
                  <div class="type-list-price">
                    <div>¥{{ val.Price }}</div>
                    <div>
                      <el-button v-if="val.Status ===0" type="primary" @click.stop="checkDetails(val)">免费领取</el-button>
                      <div v-else :class="['status-of-img',`img-2-${val.Status}`]" />
                    </div>
                  </div>
                </div>

                <!-- 暂无数据 -->
              </template>
              <div v-else class="ecar-txt"> 暂无数据</div>
            </div>
          </div>
          <!-- /免费领取 -->

          <!-- 付费购买 -->
          <div class="type-box type-incharge">
            <div class="type-title">  <div style="position: relative;">平台推荐 <div class="dot-right-origin">荐</div> </div>  </div>
            <div class="type-list">
              <template v-if="priceBrokerageLists.length">
                <div v-for="(val,idx) in priceBrokerageLists" :key="idx" class="type-list-item">
                  <div class="type-item-tag" style="background: #FF3939;">
                    <span>推荐</span>
                  </div>
                  <div class="type-list-img" @click.stop="checkDetails(val)">
                    <img :src="val.ImageUrl" fit="cover">
                  </div>
                  <div class="type-list-name">{{ val.Name }}</div>
                  <div class="type-list-price">
                    <div>¥{{ val.Price }}</div>
                    <div>
                      <el-button v-if="val.Status ===0" type="danger" @click.stop="checkDetails(val)">立即购买</el-button>
                      <div v-else :class="['status-of-img',`img-1-${val.Status}`]" />
                    </div>
                  </div>
                </div>
              </template>
              <div v-else class="ecar-txt"> 暂无数据</div>
            </div>
          </div>
        </div>

        <!-- /付费购买 -->

      </div>
    </template>

  </iMineTemplate>
</template>

<script>
import { BaseMixin } from '@/mixins/BaseMixin'
export default {
  name: 'BrokerageCity',
  mixins: [BaseMixin],
  data() {
    return {
      loading: false,
      pageTitle: ['我的账户', '券商城'],
      activedParentKey: 1,
      activedKey: 49,
      loopImgs: [],
      // 免费内容
      freeBrokerageLists: [],
      // 付费内容
      priceBrokerageLists: [],
      totalCouponLists: [],
      urls: {
        receive: '/api_coupon/CouponMall/CouponReceive', // 免费领取
        couponLists: '/api_coupon/CouponMall/QueryCouponList', // 券商城列表
        loopImg: '/api_coupon/CouponMall/QueryCouponMalldvertisementsRe' // 轮播图片
      }
    }
  },
  mounted() {
    this.$hys.clearLoading()
    this.getData()
  },
  methods: {
    /**
     * @description: 生成指定范围的随机数
     * @param {*} minNum
     * @param {*} maxNum
     * @return {*}
     */
    randomNum(minNum, maxNum) {
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
    },

    /**
     * @description: 查看券包详情
     * @param {*} val
     * @return {*}
     */
    checkDetails(val) {
      this.$router.push({
        name: 'BrokerageDetail',
        query: {
          Id: val.Id,
          SaleCouponsMgtId: val.SaleCouponsMgtId,
          Type: val.Type
        }
      })
    },
    goRouter(item) {
      if (!item.LinkType) return
      this._jump(
        this._getTurnUrl(item.LinkType, item.LinkValue),
        item.LinkValue
      )
    },
    /**
     * @description: 购买
     * @param {*} val
     * @return {*}
     */
    // goGetOfBuy(val) {
    //   this.$router.push({
    //     name: 'BrokerageConfirmOrder',
    //     params: {
    //       dataSource: val,
    //       number: 1
    //     }
    //   })
    // },
    async  getData() {
      this.loading = true
      const res = await this.getAction(this.urls.loopImg, { from: 2 })

      if (res.IsSuccess) this.loopImgs = res.Data
      const couponList2 = await this.getAction(this.urls.couponLists, { type: 2, from: 2 })
      const couponList1 = await this.getAction(this.urls.couponLists, { type: 1, from: 2 })

      this.loading = false
      // 过滤数据，分成不同类型
      if (couponList2.IsSuccess) this.freeBrokerageLists = couponList2.Data
      if (couponList1.IsSuccess) this.priceBrokerageLists = couponList1.Data
    }
  }
}
</script>
<style lang="less" scoped>
.brokerage-container {
  width: 944px;

  .ecar-txt {
    margin: 30px auto;
    font-size: 16px;
    font-weight: 600;
    color: rgba(119, 119, 119, 1);
  }

  .banner-box {
    margin: auto;
    margin-top: 20px;
    width: 100%;
    height: 345px;

    .swiper-img {
      height: 345px;
    }
  }

  .type-free {
    background:
      linear-gradient(
        360deg,
        #FFFFFF 0%,
        #FFFFFF 75%,
        #FFFFFF 88%,
        #FFD6D6 100%
      );
  }

  .type-incharge {
    background: linear-gradient(360deg, #FFFFFF 0%, #FFFFFF 75%, #FFFFFF 88%, #FFF3C8 100%);
  }

  .type-box {
    margin-top: 16px;
    border-radius: 2px;
    width: 100%;

    .type-title {
      padding: 18px 0 12px 20px;
      font-size: 18px;
      font-weight: 600;
      text-align: left;
      color: #1E263F;

      .dot-right-blue {
        position: absolute;
        top: 0;
        left: 75px;
        border: 1px solid #FFFFFF;
        border-radius: 8px 8px 8px 0;
        width: 30px;
        height: 19px;
        font-size: 12px;
        text-align: center;
        color: #FFFFFF;
        background: linear-gradient(315deg, #5FA4FE 0%, #0F6EEA 100%);
      }

      .dot-right-origin {
        position: absolute;
        top: 0;
        left: 75px;
        border: 1px solid #FFFFFF;
        border-radius: 8px 8px 8px 0;
        width: 30px;
        height: 19px;
        font-size: 12px;
        text-align: center;
        color: #FFFFFF;
        background: linear-gradient(315deg, #FC7D51 0%, #F64737 100%);
      }
    }
  }

  .type-list {
    display: flex;
    flex-wrap: wrap;

    .type-list-item {
      position: relative;
      overflow: hidden;
      margin-top: 8px;
      margin-bottom: 8px;
      margin-left: 20px;
      border: 1px solid #E8E8E8;
      border-radius: 4px;
      padding: 8px;
      width: 288px;
      height: 212px;

      &:hover {
        border: 1px solid #409EFF;
      }

      .type-item-tag {
        position: absolute;
        top: 3px;
        left: -32px;
        width: 100px;
        height: 28px;
        font-size: 14px;
        text-align: center;
        color: #FFFFFF;
        background: #0F6EEA;
        line-height: 28px;
        transform:
          rotate(
            -45deg
          );
      }
    }

    .type-list-img {
      img {
        border-radius: 8px;
        width: 272px;
        height: 120px;
      }

      &:hover {
        cursor: pointer;
      }
    }

    .type-list-name {
      overflow: hidden;
      margin: 12px 0 14px;
      max-width: 100%;
      height: 18px;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #111A34;
      line-height: 16px;
    }

    .type-list-price {
      display: flex;
      justify-content: space-between;

      // 图片区域
      .status-of-img {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 90px;
        height: 73px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .img-2-1 {
        background-image: url("../../assets/BrokerageCity/getted.png");
        margin-right: -9px;
      }

      .img-2-2 {
        background-image: url("../../assets/BrokerageCity/outOfAmount.png");
        margin-right: -9px;
      }

      .img-1-1 {
        background-image: url("../../assets/BrokerageCity/boughted.png");
        margin-right: -9px;
      }

      .img-1-2 {
        background-image: url("../../assets/BrokerageCity/solt-out.png");
        margin-right: -9px;
      }

      & > div:nth-child(1) {
        font-size: 24px;
        font-weight: 800;
        color: #FF3939;
      }

      & > div:nth-child(2) {
        button {
          display: flex;
          align-items: center;
          width: 104px;
          height: 32px;
          align-content: center;
        }
      }
    }
  }
}
</style>
